import styled from "styled-components";

import { breakpoint } from "@utilities";
import { Z_INDEX } from "@constants";

export const StyledSearchDesktopComponent = styled.div<{
    $isShowFilter: boolean;
    width: number;
}>`
    box-shadow: 0px 10px 107px 3px rgba(0, 0, 0, 0.1);
    /* Matches the .searchBox inside. Without it the shadow is cast by a square
       box, and its corners sit outside the rounded bar they belong to. */
    border-radius: 12px;

    ${breakpoint.breakTablet`
        position: absolute;
        top: 50%;
        left: 49.75%;
        width: ${(p) => p.theme.widths.wide_700};
        transform: translate(-50%, -50%);

        .mobile {
            display: none !important;
        }
    `}

    ${breakpoint.breakIpadPro`
        width: ${(p) => p.theme.widths.wide_898};
    `}

    ${breakpoint.breakLarge`
        width: ${(p) => p.theme.widths.wide_1104};
    `}

    .searchBox {
        display: flex;
        background-color: #fff;
        border-radius: 12px;

        ${breakpoint.breakOnlyMobile`
            height: 58px;
        `}

        ${breakpoint.breakTablet`
            height: 44px;
        `}

        ${breakpoint.breakIpadPro`
            height: 60px;
        `}
    }

    .searchIcon {
        flex: ${(p) => (p.$isShowFilter ? "80" : "90")};
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);

        ${breakpoint.breakOnlyMobile`
        display: none;
    `}

        svg {
            ${breakpoint.breakTablet`
            width: 18px;
        `}
            ${breakpoint.breakIpadPro`
            width: 24px;
        `}
        }
    }

    .inputBox {
        flex: ${(p) => (p.$isShowFilter ? "911" : "629")};
        padding: 6px 10px;
        border-right: 1px solid ${(p) => p.theme.colors.gray_5};
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        flex-direction: row;

        ${breakpoint.breakOnlyMobile`
            flex: 288;
            padding: 16px 20px 16px 16px;
        `}

        ${breakpoint.breakIpadPro`
            padding: 13px 10px;
        `}

        .searchIconMobile {
            position: absolute;
            top: 50%;
            left: 35px;
            transform: translateY(-50%);
        }

        input {
            width: 100%;
            height: 100%;
            background-color: #fff;
            padding: 12px 14px 12px 44px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            /* The left-hand segment of the bar, so it matches the container on
               the outer edge and stays square where the Filter button abuts it. */
            border-radius: 12px 0 0 12px;

            ${breakpoint.breakOnlyMobile`
                padding: 14px 14px 14px 52px;
            `}

            ${breakpoint.breakTablet`
                font-size: 12px;
            `}

            ${breakpoint.breakIpadPro`
                font-size: 16px;
            `}

            &::placeholder {
                color: ${(p) => p.theme.colors.gray_3};
            }
        }
    }

    .filterBtn {
        position: relative;
        /* Matched to .searchBtn so the two sit at the same width. */
        flex: ${(p) => (p.$isShowFilter ? "119" : "180")};
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: ${(p) => (p.$isShowFilter ? p.theme.colors.black : "#fff")};

        ${breakpoint.breakOnlyMobile`
            flex: 87;
        `}

        button {
            color: ${(p) => (p.$isShowFilter ? "#fff" : p.theme.colors.black)};
            font-size: 12px;
            font-weight: 700;
            line-height: 26px;
            display: flex;
            justify-content: center;
            align-items: center;

            ${breakpoint.breakOnlyMobile`
                flex-direction: column;
                font-size: 16px;
                font-weight: 700;
                line-height: 26px;
            `}

            ${breakpoint.breakTablet`
                font-size: 12px;
            `}

            ${breakpoint.breakIpadPro`
                font-size: 16px;
            `}
        }

        span {
            margin-left: 5px;

            ${breakpoint.breakIpadPro`
                margin-left: 12px;
            `}
        }

        svg {
            ${breakpoint.breakTablet`
                width: 18px;
            `}
            ${breakpoint.breakIpadPro`
                width: 24px;
            `}
            path {
                stroke: ${(p) => (p.$isShowFilter ? "#fff" : p.theme.colors.main)};
            }
        }
        //Todo: needs to be implemented after design is ready
        // .filter-count {
        //     background-color: ${(p) => (p.$isShowFilter ? p.theme.colors.black : "#fff")};
        //     color: ${(p) => (p.$isShowFilter ? "#fff" : p.theme.colors.black)};
        //     font-size: 13px;
        //     font-weight: 700;
        //     margin-left: 4px;
        //     border-radius: 4px;
        //     display: inline-flex;

        //     ${breakpoint.breakTablet`
        //         font-size: 10px;
        //     `}

        //     ${breakpoint.breakIpadPro`
        //         font-size: 13px;
        //     `}
        // }
    }

    .searchBtn {
        /* Matched to .filterBtn above — the two were 136 against 255. */
        flex: 180;
        display: ${(p) => (p.$isShowFilter ? "none" : "block")};

        ${breakpoint.breakOnlyMobile`
            display: none;
        `}

        button {
            margin-top: 0;
            height: 100%;
            /* Outer corners only: this is the right-hand segment of the search
               bar, so rounding the inner edge would notch it away from the Filter
               button beside it. */
            border-radius: 0 12px 12px 0;
            /* Yellow whatever StyledButton's shared disabled rule would paint:
               that grey is for buttons standing on their own, and here it made the
               search bar look broken rather than waiting for a filter. */
            background: ${(p) => p.theme.colors.main};
            /* Matched to the Filter label beside it, step for step, so the two
               halves of the bar read as one control. */
            font-size: 12px;

            ${breakpoint.breakTablet`
                font-size: 12px;
            `}

            ${breakpoint.breakIpadPro`
                font-size: 16px;
            `}
        }
    }

    .filterBox {
        transition: 300ms;
        display: ${(p) => (p.width > 767 ? (p.$isShowFilter ? "block" : "none") : "block")};
        transform: ${(p) =>
            p.width < 767 ? (p.$isShowFilter ? "translateX(0)" : "translateX(100%)") : "unset"};

        @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            z-index: ${Z_INDEX.MODAL_CONTENT};
            max-height: 100vh;
            overflow-y: auto;
            padding-top: 90px;
        }
    }

    .searchBtnMobile {
        padding: 10px 16px 10px 16px;
        background-color: #fff;
        border-top: 1px solid ${(p) => p.theme.colors.gray_5};
        display: block;

        button {
            margin-top: 0;
            /* Overrides StyledButton's disabled grey as well, so the button keeps
               the brand colour before a search term has been typed. */
            background: ${(p) => p.theme.colors.main};
        }
    }
`;
